var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "180px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "套餐订单号/服务编号/就诊人姓名" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.keyword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "keyword", $$v)
                                },
                                expression: "listPram.keyword",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "服务状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth mr20",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.serviceStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "serviceStatus", $$v)
                                },
                                expression: "listPram.serviceStatus",
                              },
                            },
                            _vm._l(_vm.stateMap, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.dateList,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "dateList", $$v)
                              },
                              expression: "listPram.dateList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.handerSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "success" },
                      on: { click: _vm.goUserCouponImport },
                    },
                    [_vm._v("导入优惠券")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "serviceNo",
                  label: "服务编号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "套餐订单号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceName",
                  label: "服务名称",
                  "min-width": "260",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "patientName",
                  label: "就诊人姓名",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceStatusName",
                  label: "服务状态",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        scope.row.serviceStatus !== -1 &&
                        (scope.row.serviceCode == "COMPANION_MEDICAL_SERVICE" ||
                          scope.row.serviceCode == "OUTPATIENT_SERVICE")
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.canleClose(scope.row, 1)
                                  },
                                },
                              },
                              [_vm._v("取消 ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.serviceStatus == 0 ||
                        scope.row.serviceStatus == 2
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.canleClose(scope.row, 2)
                                  },
                                },
                              },
                              [_vm._v("上传结果")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.serviceStatus == 1 ||
                        scope.row.serviceStatus == 3
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.canleClose(scope.row, 3)
                                  },
                                },
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisibleDetals,
            width: "65%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetals = $event
            },
          },
        },
        [
          _vm.popupDetales.patientJson
            ? _c(
                "div",
                { staticStyle: { padding: "8px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                        "margin-bottom": "12px",
                      },
                    },
                    [_vm._v("就诊人信息")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        "margin-bottom": "8px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "姓名：" +
                            _vm._s(_vm.popupDetales.patientJson.patientName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "性别：" +
                            _vm._s(_vm.popupDetales.patientJson.patientSex)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "年龄：" +
                            _vm._s(_vm.popupDetales.patientJson.patientAge)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "联系号码：" +
                            _vm._s(_vm.popupDetales.patientJson.patientPhone)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "家属手机号：" +
                            _vm._s(_vm.popupDetales.patientJson.parentPhone)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { padding: "8px 0" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "font-size": "16px",
                    "margin-bottom": "12px",
                  },
                },
                [_vm._v("服务信息")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    "margin-bottom": "8px",
                  },
                },
                [
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _vm._v("服务名称：" + _vm._s(_vm.popupDetales.serviceName)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _vm._v("服务编号：" + _vm._s(_vm.popupDetales.serviceNo)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _vm._v("套餐订单号：" + _vm._s(_vm.popupDetales.orderNo)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "25%" } }, [
                    _vm._v("创建时间：" + _vm._s(_vm.popupDetales.createTime)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
                _vm._v("\n      状态：\n      "),
                _c("span", { staticStyle: { color: "#409EFF" } }, [
                  _vm._v(_vm._s(_vm.popupDetales.serviceStatusName)),
                ]),
              ]),
              _vm._v(" "),
              _vm.popupDetales.serviceJson
                ? _c(
                    "div",
                    { staticStyle: { "margin-bottom": "12px" } },
                    [
                      _vm._v("\n      下载体检报告：\n        "),
                      _c(
                        "el-link",
                        {
                          staticStyle: { "margin-left": "16px" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleExprot(
                                _vm.popupDetales.serviceJson.examineFileUrl
                              )
                            },
                          },
                        },
                        [_vm._v("点击下载")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider"),
            ],
            1
          ),
          _vm._v(" "),
          _vm.popupDetales.accompanyJson
            ? _c(
                "div",
                { staticStyle: { padding: "8px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                        "margin-bottom": "12px",
                      },
                    },
                    [_vm._v("陪诊人信息")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        "margin-bottom": "8px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "陪诊人姓名：" +
                            _vm._s(_vm.popupDetales.accompanyJson.accompanyName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "性别：" +
                            _vm._s(_vm.popupDetales.accompanyJson.accompanySex)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "年龄：" +
                            _vm._s(_vm.popupDetales.accompanyJson.accompanyAge)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "联系号码：" +
                            _vm._s(
                              _vm.popupDetales.accompanyJson.accompanyPhone
                            )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
                    _vm._v("\n      图片："),
                    _c("img", {
                      staticStyle: { width: "74px", height: "74px" },
                      attrs: {
                        src: _vm.popupDetales.accompanyJson.accompanyPhotoUrl,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.popupDetales.disposeJson
            ? _c(
                "div",
                { staticStyle: { padding: "8px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                        "margin-bottom": "12px",
                      },
                    },
                    [_vm._v("处理信息")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        "margin-bottom": "8px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "处理人：" +
                            _vm._s(_vm.popupDetales.disposeJson.adminName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "35%" } }, [
                        _vm._v(
                          "最后处理时间：" +
                            _vm._s(_vm.popupDetales.disposeJson.operateTime)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "40%" } }, [
                        _vm._v(
                          "联系方式：" +
                            _vm._s(_vm.popupDetales.disposeJson.adminPhone)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
                    _vm._v("\n      处理结果："),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.popupDetales.disposeJson.content),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.popupDetales.formJson
            ? _c(
                "div",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "font-size": "16px",
                    "margin-bottom": "12px",
                  },
                },
                [
                  _vm._v("用户提交信息\n      "),
                  _c(
                    "el-link",
                    {
                      staticStyle: { "margin-left": "16px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.exportFormJsonToExcel },
                    },
                    [_vm._v("数据导出(Excel)")]
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.popupDetales.cancelJson
            ? _c(
                "div",
                { staticStyle: { padding: "8px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                        "margin-bottom": "12px",
                      },
                    },
                    [_vm._v("取消信息")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        "margin-bottom": "8px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "取消人：" +
                            _vm._s(_vm.popupDetales.cancelJson.cancelAdminName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v(
                          "取消时间：" +
                            _vm._s(_vm.popupDetales.cancelJson.cancelTime)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "25%" } }, [
                        _vm._v("取消结果：\n\t\t"),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.popupDetales.cancelJson.content
                            ),
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.popupDetail, width: "65%" },
          on: {
            "update:visible": function ($event) {
              _vm.popupDetail = $event
            },
          },
        },
        [
          _vm.num == 1
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    "font-size": "26px",
                    "font-weight": "700",
                  },
                },
                [_vm._v("\n\t\t\t\t取消原因：\n\t\t\t")]
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.num == 2 || _vm.num == 3) &&
          _vm.objRow.serviceCode == "COMPANION_MEDICAL_SERVICE"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.request, "label-width": "120px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "陪诊人*", required: "" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入内容" },
                            model: {
                              value: _vm.request.accompanyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.request, "accompanyName", $$v)
                              },
                              expression: "request.accompanyName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话*", required: "" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入内容" },
                            model: {
                              value: _vm.request.accompanyPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.request, "accompanyPhone", $$v)
                              },
                              expression: "request.accompanyPhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.request.accompanySex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.request, "accompanySex", $$v)
                                },
                                expression: "request.accompanySex",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "男" } }, [
                                _vm._v("男"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "女" } }, [
                                _vm._v("女"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年龄" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入内容" },
                            model: {
                              value: _vm.request.accompanyAge,
                              callback: function ($$v) {
                                _vm.$set(_vm.request, "accompanyAge", $$v)
                              },
                              expression: "request.accompanyAge",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "照片" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "",
                                "http-request": _vm.handleUploadFormNew,
                                headers: _vm.myHeaders,
                                "show-file-list": false,
                                multiple: "",
                              },
                            },
                            [
                              _vm.request.accompanyPhotoUrl
                                ? _c("img", {
                                    staticStyle: {
                                      width: "70px",
                                      height: "70px",
                                    },
                                    attrs: {
                                      src: _vm.request.accompanyPhotoUrl,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "mr10",
                                  attrs: { type: "primary" },
                                },
                                [_vm._v("上传图片")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.num == 2 || _vm.num == 3) &&
          _vm.objRow.serviceCode == "OUTPATIENT_SERVICE"
            ? _c(
                "div",
                [
                  _vm._v("\n\t\t\t\t\t就诊时间 "),
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" :\n\t\t\t\t\t"),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "选择日期时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.request.patientTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.request, "patientTime", $$v)
                      },
                      expression: "request.patientTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Tinymce", {
            ref: "tinymceEditor",
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "30px" } },
            [
              _c("el-button", { on: { click: _vm.handleSubmitText } }, [
                _vm._v("提交"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.popupDetail = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }